import React, { createContext, useContext, useState, ReactNode } from 'react';
import { SrpFilterValues } from 'types/srpFilters';
import { DeepPartial } from 'types/util';

export type PartialSrpFilterValues = DeepPartial<SrpFilterValues>;

interface FilterContextType {
  filterData: PartialSrpFilterValues;
  updateFilterData: (newFilterData: Partial<PartialSrpFilterValues>) => void;
  clearFilterData: () => void;
}

const OnboardingFilterContext = createContext<FilterContextType | undefined>(undefined);

export const OnboardingFilterProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [filterData, setFilterData] = useState<PartialSrpFilterValues>({});

  const updateFilterData = (newFilterData: Partial<PartialSrpFilterValues>): void => {
    setFilterData((currentFilterData) => {
      return {
        ...currentFilterData,
        ...newFilterData,
      };
    });
  };

  const clearFilterData = (): void => setFilterData({});

  return (
    <OnboardingFilterContext.Provider value={{ filterData, updateFilterData, clearFilterData }}>
      {children}
    </OnboardingFilterContext.Provider>
  );
};

export const useFilterContext = (): FilterContextType => {
  const context = useContext(OnboardingFilterContext);
  if (context === undefined) {
    throw new Error('useFilterContext must be used within a OnboardingFilterProvider');
  }
  return context;
};
